import { ProspectEntity } from "../entity/ProspectEntity";
import { ProspectGateway } from "../gateway/PropsectGateway/ProspectGateway";

export class GetProspectByIdUsecase {
    constructor() {
        this.ProspectGateway = new ProspectGateway();
    }

    async execute({ _id } = {}) {
        const payload = this.sanitizeInput({ _id });
        if (!payload._id) return null;
        const prospect = await this.ProspectGateway.getById(payload._id);
        if (!prospect?.response) return null;
        const prospectEntity = ProspectEntity.restore(prospect.response);
        return prospectEntity;
    }

    sanitizeInput({ _id } = {}) {
        const sanitizedId =
            _id === undefined || _id === null ? "" : String(_id).trim();
        return { _id: sanitizedId || null };
    }
}
